export function NestSvg({ size = 80 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size * 0.6}
      viewBox="0 0 120 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Basket base */}
      <ellipse cx="60" cy="52" rx="50" ry="16" fill="#E8DFD0" />
      <ellipse cx="60" cy="48" rx="46" ry="14" fill="#F3EBD8" />
      {/* Stitch arcs */}
      {Array.from({ length: 8 }).map((_, i) => {
        const x = 20 + i * 12;
        return (
          <path
            key={i}
            d={`M${x} 48 Q${x + 6} 38 ${x + 12} 48`}
            stroke="#C9B998"
            strokeWidth="1.5"
            strokeLinecap="round"
            fill="none"
          />
        );
      })}
      {Array.from({ length: 7 }).map((_, i) => {
        const x = 26 + i * 12;
        return (
          <path
            key={`b-${i}`}
            d={`M${x} 52 Q${x + 6} 42 ${x + 12} 52`}
            stroke="#C9B998"
            strokeWidth="1.2"
            strokeLinecap="round"
            fill="none"
            opacity="0.6"
          />
        );
      })}
      {/* Rim */}
      <ellipse cx="60" cy="44" rx="48" ry="4" fill="#D4C5A8" opacity="0.5" />
    </svg>
  );
}
